import { useEffect, useState } from "react";
import { useOccurrenceRegister } from "contexts/register/OccurrenceContext";
import { fireToast } from "services/sweetAlertConfig";
import Input from "../../../Input";
import Maps from "../../../Map";
import MaskedInput from "../../../MaskedInput";

import * as S from "./styles";
import { AutoComplete } from "components/Autocomplete";

type Props = {
  onVehicleLocationChange: (quantity: number) => void;
};

function VehicleForm({ onVehicleLocationChange }: Props) {
  const { setOccurrence, setVehicle, vehicle, errors } =
    useOccurrenceRegister();
    const convertLabel: {[key:string]:string} = {
      truck:'Caminhão',
      motorcycle:'Moto',
      car:'Carro',
      bike:'Bicicleta',
      bus:'Onibus',
      }
        
  const [lastCoordY, setLastCoordY] = useState(0);
  const [type, setType] = useState('');
  const [lastCoordX, setLastCoordX] = useState(0);

  useEffect(() => {
    if (lastCoordY !== 0)
      setOccurrence((value) => {
        value.lastCoordX = lastCoordX;
        value.lastCoordY = lastCoordY;
        return value;
      });
  }, [lastCoordY, lastCoordX]);

  function addCoords() {
    if (lastCoordX !== 0) {
      setOccurrence((value) => {
        if (value.lastCoords) {
          value.lastCoords = [...value.lastCoords, [lastCoordX, lastCoordY]];
        } else {
          value.lastCoords = [[lastCoordX, lastCoordY]];
        }

        onVehicleLocationChange(value.lastCoords.length);

        fireToast(
          "Localização adicionada com sucesso (não se esqueça de salvar antes de fechar)"
        );

        return value;
      });
    }
  }

  return (
    <S.Wrapper>
      <S.Form>
        <Input
          containerClassName="form-div"
          id="Marca"
          name="Marca"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setVehicle((value) => {
              value.brand = event.target.value;
              return value;
            });
          }}
          defaultValue={vehicle.brand}
          label="Marca"
          required={true}
          error={errors.brand}
          type="text"
        />
        <Input
          containerClassName="form-div"
          id="Modelo"
          name="Modelo"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setVehicle((value) => {
              value.model = event.target.value;
              return value;
            });
          }}
          defaultValue={vehicle.model}
          label="Modelo"
          required={true}
          error={errors.model}
          type="text"
        />

        {type !== 'bike' && <MaskedInput
          containerClassName="form-div"
          id="Placa"
          name="Placa"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setVehicle((value) => {
              value.plate = event.target.value;
              return value;
            });
          }}
          defaultValue={vehicle.plate}
          label="Placa"
          mask="aaa-9*99"
          required={true}
          error={errors.plate}
          type="text"
        />}
        <Input
          id="Cor"
          name="Cor"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setVehicle((value) => {
              value.color = event.target.value;
              return value;
            });
          }}
          defaultValue={vehicle.color}
          label="Cor"
          required={true}
          error={errors.color}
          type="text"
        />
        <Input
          containerClassName="form-div"
          id="Descrição"
          name="Descrição"
          onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
            setVehicle((value) => {
              value.description = event.target.value;
              return value;
            });
          }}
          defaultValue={vehicle.description}
          label="Descrição"
          required={true}
          type="text"
        />
      <AutoComplete
        label='Tipo do veículo'
        options={[
          {label:'Caminhão',value:'truck'},
          {label:'Moto',value:'motorcycle'},
          {label:'Carro', value:'car'},
          {label:'Bicicleta', value:'bike'},
          {label:'Onibus', value:'bus'}
        ]}
        defaultValue={vehicle.type ? { label:convertLabel[vehicle.type], value:vehicle.type} : {label:'Carro', value:'car'}}
        onChange={(selected:any)=>{
          setType(selected.value)
          setVehicle((value) => {
            
            value.type = selected.value
            return value;
          });
        }}
       />
      </S.Form>
    </S.Wrapper>
  );
}

export { VehicleForm };
